"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const emailVerificationStates_1 = require("./emailVerificationStates");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1({ emailVerificationForm, apiMidPath, }) {
    var _a, _b;
    const { watch, formState: { errors }, setError, setFocus, clearErrors, setValue, resetField, } = emailVerificationForm;
    const email = watch('email');
    const isEmailUnique = (0, recoil_1.useRecoilValue)(emailVerificationStates_1.isEmailUniqueState);
    const resetIsEmailUnique = (0, recoil_1.useResetRecoilState)(emailVerificationStates_1.isEmailUniqueState);
    const [isEmailVerified, setIsEmailVerified] = (0, recoil_1.useRecoilState)(emailVerificationStates_1.isEmailVerifiedState);
    const resetIsEmailVerified = (0, recoil_1.useResetRecoilState)(emailVerificationStates_1.isEmailVerifiedState);
    const setEmailVerifyTimeLimit = (0, recoil_1.useSetRecoilState)(emailVerificationStates_1.emailVerifyTimeLimitState);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const confirmVerificationEmailSent = () => {
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('email로', { email }), (0, jsx_runtime_1.jsx)("br", {}), t('인증번호를 보냈어요!')] })),
            confirmationButtonProps: { autoFocus: !maxWidth768 },
            cancellationButtonProps: { style: { display: 'none' } },
        })
            .then(() => setFocus('veriCode'))
            .catch(() => { });
    };
    const [isSending, setIsSending] = (0, react_1.useState)(false);
    const sendEmailCounterRef = (0, react_1.useRef)(0);
    const FIFTEEN_MIN = 15 * 60 * 1000;
    const sendVerificationEmail = () => __awaiter(this, void 0, void 0, function* () {
        if (sendEmailCounterRef.current >= 5) {
            (0, errors_1.havingDifficulties)(confirm);
        }
        else if (!isSending) {
            setIsSending(true);
            (0, functions_1.tempDisableClick)(500);
            yield (0, api_1.postData)(`/api/v1/${apiMidPath}/send-verification-email`, { email })
                .then(() => {
                clearErrors('veriCode');
                setValue('veriCode', '');
                confirmVerificationEmailSent();
                setIsEmailVerified('proceeding');
                setEmailVerifyTimeLimit(new Date().getTime() + FIFTEEN_MIN);
                sendEmailCounterRef.current++;
            })
                .catch(error => (0, _1.handleEmailVerificationError)(error, setError))
                .finally(() => setIsSending(false));
        }
    });
    const resetEmailVerification = () => {
        confirm({
            description: t('이메일을 변경하시겠어요?'),
            confirmationText: t('변경할게요'),
        })
            .then(() => {
            resetField('email');
            resetField('veriCode');
            resetIsEmailUnique();
            resetIsEmailVerified();
            sendEmailCounterRef.current = 0;
        })
            .catch(() => { });
    };
    const { capsLockErrorMsg, detectCapsLock } = (0, detect_utils_1.useDetectCapsLock)();
    const duplicateEmailErrMsg = isEmailUnique === false ? _1.emailVeriErrMsgObj.duplicated() : '';
    const emailErrMsg = capsLockErrorMsg || ((_a = errors.email) === null || _a === void 0 ? void 0 : _a.message) || duplicateEmailErrMsg || ((_b = errors.veriCode) === null || _b === void 0 ? void 0 : _b.message);
    const isSignUp = apiMidPath === 'sign-up';
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_1.EmailInput, { emailVerificationForm: emailVerificationForm, sendVerificationEmail: sendVerificationEmail, resetEmailVerification: resetEmailVerification, detectCapsLock: detectCapsLock, isSignUp: isSignUp }), Boolean(isEmailVerified) && ((0, jsx_runtime_1.jsx)(_1.VeriCodeInput, { emailVerificationForm: emailVerificationForm, sendVerificationEmail: sendVerificationEmail, apiMidPath: apiMidPath })), emailErrMsg ? ((0, jsx_runtime_1.jsx)("h5", Object.assign({ className: "error-main" }, { children: emailErrMsg }))) : (isEmailVerified === 'proceeding' && ((0, jsx_runtime_1.jsx)("h5", Object.assign({ className: "gray-80" }, { children: t('인증번호를 받지 못한 경우, 스팸함을 확인해주세요!') }))))] }));
}
exports.default = default_1;
